module.exports = __webpack_public_path__ + "img/en.0b5b9bd4.svg";